import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const ShareIcon = (props) => {
  const classes = useStyles()();
  const color = props?.color || colorsPalette.white;

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <circle className={classes.element} cx="5" cy="12.00001" r="3" />
      <circle className={classes.element} strokeWidth="2" cx="19" cy="5.00001" r="3" />
      <line
        className={classes.element}
        strokeWidth="2"
        x1="16.3164"
        y1="6.3418"
        x2="7.6836"
        y2="10.65821"
      />
      <line
        className={classes.element}
        strokeWidth="2"
        x1="7.6836"
        y1="13.3418"
        x2="16.3164"
        y2="17.65821"
      />
      <circle className={classes.element} strokeWidth="2" cx="19" cy="19.00001" r="3" />
    </svg>
  );
};
export default ShareIcon;
